import React from 'react';
import { getLocale, useIntl } from 'umi';
import cx from 'classnames'
import TextBubbles from '@/pages/home/components/TextBubbles';
import { formatNum, formatPercentNum, getIsErrorValue } from '@/pages/dashboard/utils/utils';
import { Bubble, Card, Icon, ImagePreview, Text } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import errorImg from '@/pages/dashboard/assets/images/funnel/step.png';

import './index.scss';

const ItemCard = (props: any) => {
  const { data, stepOptions, index } = props;
  const { formatMessage } = useIntl()
  const title = stepOptions?.find((v: any) => v?.value === data?.stage_name)?.text || data?.stage_name
  const { dod, sdlw, lost } = data || {}
  const otherData: any = index === 0 ? { dod, sdlw } : { dod, sdlw, lost }

  // 浮窗提示
  const bubbleContentList = (() => {
    const keys = Object.keys(otherData);
    return keys.map((key) => {
      return {
        key: key,
        title: formatMessage({ id: `overview_${key}` }),
        ...otherData[key]
      }
    });
  })();

  // 卡片下方显示同比和环比涨跌的组件
  const UpsAndDownsComparison = () => {
    const keys = Object.keys(otherData);
    return (
      keys?.map((key, ki) => {
        const { show_value } = otherData?.[key] || {};
        const correctVal = !getIsErrorValue(show_value);
        const val = !(Number(show_value) < 0);
        return <div className="device-text">
          <div key={ki + 'title'} className='device-text-title'>{formatMessage({ id: `overview_${key}` })}</div>
          <div key={ki} className={cx({ 'overlay-card-body-textnum': true }, { ["text-green"]: correctVal && val }, { ["text-red"]: correctVal && !val })}>
            {correctVal ? formatPercentNum(parseFloat(show_value), 1, true) : <span className="data-null"> -</span>}
            {
              correctVal && ((Number(show_value) === 0)
                ? <Icon type={'trend-zero'} />
                : (Number(show_value) > 0)
                  ? <SvgIcon className='overlay-card-body-icon' type="green-up-new" />
                  : <SvgIcon className='overlay-card-body-icon' type="red-down-new" />)
            }
          </div>
        </div>
      })
    )
  }

  const itemCont = (data: any, ind: number) => {
    if (!data) return
    const { key, title, this_time, last_time, this_value, last_value } = data || {};
    const new_last_time = key === 'lost' ? (stepOptions?.find((v: any) => v?.value === last_time)?.text || last_time) : last_time
    const isEn = getLocale() === 'en-US'
    const explain = key === 'dod' ? 'Day on Day' : key === 'sdlw' ? 'Same Day Last Week' : null
    let topVal
    topVal = formatNum(parseFloat(this_value), false);
    if (key === 'lost' && this_value) {
      const valueArr = this_value?.split('-')?.map((item: any) => formatNum(parseFloat(item), false))
      topVal = valueArr?.[0] + '-' + valueArr?.[1]
    }
    const bottomVal = formatNum(parseFloat(last_value), false);
    return (
      <div className='bubble-item' key={ind + 'itemCont'}>
        <div className='bubble-title'>{title} <Text className='bubble-desc'>{isEn && explain ? `(${explain})` : ''}</Text></div>
        <div className='bubble-flex'>
          <div className='bubble-text'>
            <div className='bubble-t'>{this_time}</div>
            <div className='bubble-b'>{new_last_time}</div>
          </div>
          <div className='bubble-ct'>VS</div>
          <div className='bubble-text'>
            <div className='bubble-t'>{topVal}</div>
            <div className='bubble-b'>{bottomVal}</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="dbd-device">
      <Card className="dbd-device-item">
        <Card.Body>
          <TextBubbles text={title} className="device-title" placement="top" />
          <div className="device-num">{formatPercentNum(data?.value)}</div>
          <Bubble
            trigger="hover"
            dark
            placement="bottom-start"
            style={{ maxWidth: 350 }}
            content={bubbleContentList.map((i, ind: number) => itemCont(i, ind))}
          >
            <div>
              {UpsAndDownsComparison()}
            </div>
          </Bubble>
        </Card.Body>
        {index < 5 && <SvgIcon className="device-icon" type="right-arrow-icon" />}
      </Card>
      <div className="dbd-device-img">
        <ImagePreview
          className="device-img"
          modalClassName="device-modal"
          src={data?.stage_image || errorImg}
          previewSrc={data?.stage_image || errorImg}
          maskClosable={true}
        />
      </div>
    </div>
  );
};

export default ItemCard;
